import {POSTHOG_API_KEY} from '../constants.js';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

export const posthogCapture = (...posthogArgs) => {
  if (!POSTHOG_API_KEY) {
    return;
  }
  try {
    posthog.capture(...posthogArgs);
  } catch (err) {
    Sentry.captureException(err, {extra: posthogArgs});
  }
};
